import { Culture } from '../../types';

export const cocopah: Culture = {
  name: 'Cocopah Indian Tribe',
  languageFamily: 'Yuman-Cochimí',
  terms: [
    {
      word: 'Avikwame',
      phonetic: 'ah-vee-kwah-may',
      description: 'Sacred mountain in Cocopah culture.'
    },
    {
      word: 'Kwapa',
      phonetic: 'kwah-pah',
      description: 'Cocopah name for themselves, meaning "River People."'
    },
    {
      word: 'Nyeʼe',
      phonetic: 'nyay-eh',
      description: 'Cocopah word for "spirit" or "soul."'
    }
  ]
};